export function handleKendoUpload(selector) {
	kendoUpload(selector);
	asyncKendoUpload(selector);
}

function kendoUpload(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[kendo-upload]');
	} else {
		var $cont = $(selector + ' [kendo-upload]');
	}

	$cont.each(function (idx) {
		let $uploadContainer = $(this);

		let confMultiple = $uploadContainer.data('upload-multiple');
		if (typeof confMultiple === 'undefined') {
			confMultiple = false;
		}

		let confShowList = $uploadContainer.data('upload-show-file-list');
		if (typeof confShowList === 'undefined') {
			confShowList = false;
		}

		let $inp = $uploadContainer.find('input[type="file"]');
		let $dropZone = $uploadContainer.find('.dropZoneElement');

		$inp.kendoUpload({
			multiple: confMultiple,
			showFileList: confShowList,
		});
	});
}

function asyncKendoUpload(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[kendo-upload-async]');
	} else {
		var $cont = $(selector + ' [kendo-upload-async]');
	}

	$cont.each(function (idx) {
		let $uploadContainer = $(this);

		let confMultiple = $uploadContainer.data('upload-multiple');
		if (typeof confMultiple === 'undefined') {
			confMultiple = false;
		}

		let confShowList = $uploadContainer.data('upload-show-file-list');
		if (typeof confShowList === 'undefined') {
			confShowList = false;
		}

		let confUploadAction = $uploadContainer.data('upload-action');
		if (typeof confUploadAction === 'undefined') {
			confUploadAction = null;
		}

		let $inp = $uploadContainer.find('input[type="file"]');
		let $dropZone = $uploadContainer.find('.dropZoneElement');

		$inp.kendoUpload({
			multiple: confMultiple,
			async: {
				saveUrl: $uploadContainer.attr('kendo-upload-async'),
				autoUpload: true,
				saveField: $inp.attr('name')
			},
			showFileList: confShowList,
			dropZone: '#' + $dropZone.attr('id'),
			upload: function (e) {
				if (confUploadAction) {
					e.data = {
						_do: confUploadAction,
					};
				}

				var xhr = e.XMLHttpRequest;
				if (xhr) {
					xhr.addEventListener("readystatechange", function (e) {
						if (xhr.readyState == 1 /* OPENED */) {
							xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
						}
					});
				}
			},
			success: function (e) {
				if (e.operation == "upload") {
					staticNotification.success('Soubor úpěšně odeslán a uložen na serveru!');
					najaGlobal.snippetHandler.updateSnippets(e.response.snippets);
				}
			}
		});
	});

}
